import { Indicator } from '../../../Common/Charts/Indicator';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const IndicatorCID = () => {
    const { emptyIndicator } = useServicesChartsDataContext();

    return (
        <Indicator
            title={`Indicador de CID em Branco`}
            indicatorValue={emptyIndicator}
            height={200}
        />
    );
};
